/**
 * Request bodies for `/api/friends/*` and `/api/users/search`.
 *
 * Every one of these routes is authenticated and identifies the *other* party by
 * username or by a uuid the caller was given, never by a numeric id — so there
 * is nothing here to enumerate with.
 */
import { z } from 'zod';
import { USER_SEARCH_MIN_LENGTH } from '../social.js';
import { usernameSchema } from './common.js';
/** `POST /api/friends/requests` — you add somebody by the name they type. */
export const friendRequestBodySchema = z.object({ username: usernameSchema });
/**
 * The `:id` of a request route and the `:userId` of a friend route are both
 * uuids the caller already holds. Validated so a malformed one is a 400 rather
 * than a Postgres cast error surfacing as a 500.
 */
export const friendIdParamSchema = z.object({ id: z.string().uuid() });
export const friendUserParamSchema = z.object({ userId: z.string().uuid() });
/**
 * Search is a prefix match with a floor of three characters. Not one: a
 * single-letter query against a user table is an enumeration primitive, and the
 * point of the feature is "I know roughly what they are called".
 */
export const userSearchQuerySchema = z.object({
    q: z.string().trim().min(USER_SEARCH_MIN_LENGTH).max(20),
});
//# sourceMappingURL=social.js.map